import React from 'react'
import PropTypes from 'prop-types'
import { Popover, Tag } from 'antd'
import { readinessTag } from './utils'

// A car's readiness in the cars list: "Ready", or "Needs N things" with the list on hover. The server
// decides what is missing (the same service the Telegram bot's go-live gate uses); this only draws
// it, and draws nothing at all when the server did not say.
const ReadinessTag = ({ readiness }) => {
  const tag = readinessTag(readiness)
  if (!tag) return null
  if (tag.items.length === 0) return <Tag color={tag.color}>{tag.label}</Tag>
  return (
    <Popover
      title="Still missing"
      content={
        <ul style={{ margin: 0, paddingLeft: 18 }}>
          {tag.items.map(item => (
            <li key={item}>{item}</li>
          ))}
        </ul>
      }
    >
      <Tag color={tag.color} style={{ cursor: 'help' }}>
        {tag.label}
      </Tag>
    </Popover>
  )
}

ReadinessTag.propTypes = {
  readiness: PropTypes.shape({
    ready: PropTypes.bool,
    missing: PropTypes.arrayOf(PropTypes.shape({ key: PropTypes.string, label: PropTypes.string }))
  })
}

export default ReadinessTag
